import { BehaviorSubject } from 'rxjs';
import type { User } from '@/shared/types';

const TOKEN_KEY = 'auth_token';
const TOKEN_REFRESH_KEY = 'refresh_token';

function createAuthService() {
  const user$ = new BehaviorSubject<User | null>(null);
  const initialized$ = new BehaviorSubject<boolean>(false);

  return {
    user$,
    initialized$,
    setRefreshToken: (token: string) => localStorage.setItem(TOKEN_REFRESH_KEY, token),
    getRefreshToken: () => localStorage.getItem(TOKEN_REFRESH_KEY),
    setToken: (token: string) => localStorage.setItem(TOKEN_KEY, token),
    getToken: () => localStorage.getItem(TOKEN_KEY),
    setUser: (user: User) => user$.next(user),
    setInitialized: () => initialized$.next(true),
    logout: () => {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_REFRESH_KEY);
      user$.next(null);
    },
    isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),
  };
}

export const authService = createAuthService();
